function NXRefresh({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6668 9.66671C16.463 8.20022 15.7827 6.84142 14.7307 5.79962C13.6787 4.75782 12.3133 4.09081 10.8449 3.90133C9.37648 3.71186 7.88651 4.01044 6.6045 4.75108C5.32248 5.49171 4.31954 6.63332 3.75016 8.00004M3.3335 4.66671V8.00004H6.66683M3.3335 11.3334C3.5373 12.7999 4.21761 14.1587 5.26963 15.2005C6.32166 16.2423 7.68703 16.9093 9.15544 17.0987C10.6238 17.2882 12.1138 16.9896 13.3958 16.249C14.6778 15.5084 15.6808 14.3668 16.2502 13M16.6668 16.3334V13H13.3335"
        stroke="#A0AEC0"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default NXRefresh;
